/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IPointGroupDevice, IVideoStream } from 'application/pages/PointsGroupsPage/types';
import { CREATE_POINTS_GROUP_STEPS, createPointsGroupDefaultState } from './consts';

export const createPointsGroupSlice = createSlice({
  name: 'createPointsGroup',
  initialState: createPointsGroupDefaultState,
  reducers: {
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },

    setStep: (state, action: PayloadAction<CREATE_POINTS_GROUP_STEPS>) => {
      state.step = action.payload;
    },

    setDevices: (state, action: PayloadAction<IPointGroupDevice[] | null>) => {
      state.devices = action.payload;
    },

    addDevice: (state, action: PayloadAction<IPointGroupDevice>) => {
      if (!state.devices) {
        state.devices = [];
      }
      state.devices.push(action.payload);
    },

    removeDevice: (state, action: PayloadAction<string | number>) => {
      if (state.devices) {
        state.devices = state.devices.filter((device) => device.id !== action.payload);
      }
    },

    setMasterVideoStream: (state, action: PayloadAction<IVideoStream | null>) => {
      state.masterVideoStream = action.payload;
    },

    resetCreatePointsGroup: (state) => {
      state.title = createPointsGroupDefaultState.title;
      state.devices = createPointsGroupDefaultState.devices;
      state.masterVideoStream = createPointsGroupDefaultState.masterVideoStream;
      state.step = createPointsGroupDefaultState.step;
    },
  },
});

export const { setTitle, setDevices, addDevice, removeDevice, setMasterVideoStream, resetCreatePointsGroup, setStep } =
  createPointsGroupSlice.actions;

export const createPointsGroupReducer = createPointsGroupSlice.reducer;
